export default ({ request }) => ({
  sampleStockInListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockInMain/list',
      method: 'post',
      data
    })
  },
  sampleStockInDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billStockInMain/detail',
      method: 'post',
      data
    })
  },
  sampleStockInSaveApi(data = {}) {
    return request({
      url: '/samplemanage/billStockInMain/save',
      method: 'post',
      data
    })
  },
  sampleStockInLDelApi(data = {}) {
    return request({
      url: '/samplemanage/billStockInMain/del',
      method: 'post',
      data
    })
  },
  sampleStockInAuditApi(data = {}) {
    return request({
      url: '/samplemanage/billStockInMain/audit',
      method: 'post',
      data
    })
  }
})
